import { useEffect, useState } from 'react';
import FooterNav from '../../components/dashboard/FooterNav';
import Navbar from '../../components/dashboard/Navbar';
import Slider from '../../components/Slider';
import Main from '../../components/dashboard/Main';
import AdsComponent from '../../components/dashboard/Adsmitra';

import axios from  'axios';
import jwtDecode from 'jwt-decode';
import { Link, useNavigate } from "react-router-dom";

const verifyToken = (serviceToken) => {
    if (!serviceToken) {
        return false;
    }
    const decoded = jwtDecode(serviceToken);
    /**
     * Property 'exp' does not exist on type '<T = unknown>(token: string, options?: JwtDecodeOptions | undefined) => T'.
     */
    return decoded.exp > Date.now() / 1000;
};

const Adsmitra = () => {
    const navigate = useNavigate();
    const [token, setToken] = useState(
        JSON.parse(localStorage.getItem('token')) !== null ? 
            JSON.parse(localStorage.getItem('token')).token :
            null
    );
    const [cartState, setCartState] = useState([]);

    useEffect(() => {
        const getCart = async () => {
            try {
              const cartData = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/cart/list`, {
                headers: {
                  Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                }
              });
              setCartState(cartData.data.result);
            } catch (err) {
              console.log(err);
            }
        };
        getCart();

        if(!verifyToken(token)){
            localStorage.removeItem('token');
            navigate('/');
        }
    }, []);
    return (
        <div>
            <Navbar cartState={cartState} UpdatedCartState={setCartState} />
            <AdsComponent />
            <FooterNav />
        </div>
    )
}

export default Adsmitra;
